module.exports = __webpack_public_path__ + "img/115.fcabc236.jpg";